import React from 'react';
import { Button, Space, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftOutlined } from '@ant-design/icons';
import zoneStore from '../../Store';
import { selectZone } from '../../Store/selectionStore';
import { downloadZone } from '../../../utils/zoneTransfer';

function Header() {
  const navigate = useNavigate();
  const zone = zoneStore.useState((s) => s);

  return (
    <Space style={{ marginBottom: 12 }} wrap>
      <Button
        icon={<ArrowLeftOutlined />}
        onClick={() => navigate('/zones/')}
      />
      <Typography.Title level={4} style={{ margin: 0 }}>
        {zone.name}
      </Typography.Title>
      <Button onClick={selectZone}>Параметры зоны</Button>
      <Button onClick={() => downloadZone(zoneStore.getRawState())}>Экспорт</Button>
      <Button onClick={() => navigate(`/handle-points/${zone.id}`)}>
        Открыть в старом редакторе
      </Button>
    </Space>
  );
}

export default Header;
